import React from 'react';
import PropTypes from 'prop-types';
import { paymentCardLogos } from '@sainsburys-tech/boltui-utils';
import * as Styled from '../../../Footer.styles';

var ServiceFooter = function ServiceFooter(_ref) {
  var _ref$nativeLazy = _ref.nativeLazy,
      nativeLazy = _ref$nativeLazy === void 0 ? false : _ref$nativeLazy;
  return /*#__PURE__*/React.createElement(Styled.ServiceBlock, {
    "data-test": "footer-payment-block"
  }, paymentCardLogos.map(function (card) {
    return /*#__PURE__*/React.createElement(Styled.PaymentImage, {
      key: card.alt,
      alt: card.alt,
      src: card.imageLink,
      height: 22,
      width: 33,
      lazy: true,
      nativeLazy: nativeLazy,
      lazyWrapElement: "span"
    });
  }));
};

ServiceFooter.propTypes = {
  nativeLazy: PropTypes.bool
};
export default ServiceFooter;